import { render, staticRenderFns } from "./o-features-list.vue?vue&type=template&id=d5d8af96"
import script from "./o-features-list.vue?vue&type=script&lang=js"
export * from "./o-features-list.vue?vue&type=script&lang=js"
import style0 from "./o-features-list.vue?vue&type=style&index=0&id=d5d8af96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports